import { ExternalMedia } from './modules/external-media/index.js';
import { NewsList } from './modules/news-list/index.js';
import { Player } from './modules/player/index.js';
import { ManageAmbient } from './modules/manage-ambient/index.js';
import { LanguageMenu } from './modules/language-menu/index.js';
import { MATOMO_SITE_ID, MATOMO_URL } from '../../../data/stats-config.js';
import { matomo } from '@arr2019/stats-matomo';
import '@outbook/webcomponents-type-icon';
import { ICON_LIST } from './ui/icons/index.js';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('outbook-type-icon').forEach(el => {
    el.icons = ICON_LIST;
  });
  document.querySelectorAll('[data-href]').forEach(el => {
    el.addEventListener('click', () => {
      window.location.href = el.getAttribute('data-href');
    });
  });
  matomo({ MATOMO_SITE_ID, MATOMO_URL, enableCookies: false });
  ManageAmbient();
  LanguageMenu();
  ExternalMedia();
  NewsList();
  Player();
});
